import { render, staticRenderFns } from "./NewProjectGroup.vue?vue&type=template&id=4c549fb3&"
import script from "./NewProjectGroup.vue?vue&type=script&lang=js&"
export * from "./NewProjectGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports